export default __webpack_public_path__ + "static/media/Divertical.64b54ef0.webp";